import React, { FunctionComponent } from 'react'

import { CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic'

import { Image } from '../image/Image'

export interface AuroraAICoachAvatarIconProps {
  size?: number
}

const AI_CHAT_AVATAR_URI = `${CDN_ASSETS_LINK_BASE}/aurora/messenger/aiChatAvatar.png`

/**
 * Aurora AI Coach avatar icon - orange/yellow radial gradient sunburst design
 * Used in messenger when Aurora theme is active to replace the default AI coach avatar
 */
export const AuroraAICoachAvatarIcon: FunctionComponent<AuroraAICoachAvatarIconProps> = ({ size = 32 }) => {
  return (
    <Image
      source={{ uri: AI_CHAT_AVATAR_URI }}
      style={{ width: size, height: size }}
      accessibilityLabel='Lyra AI'
      accessibilityIgnoresInvertColors
    />
  )
}
